export default "__VITE_ASSET__fdb7b8d8__"